/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Kaufpreis)
 */
export interface PurchasePrice {
  /**
   * Monetary value in format format *eee.cc* , separated by dot.   Default currency is Euro and Cent.   (german: Geldbetrag)   (bipro-datentypen::Betrag)
   */
  amount?: string;
}
